import { useModal } from '@ebay/nice-modal-react'
import { useDispatch } from 'react-redux'
import { AnyAction, Dispatch } from 'redux'
import { Offer } from 'src/types/offer'
import { Registry } from 'src/types/registry'
import { RegItem } from 'src/types/regItem'
import { handleOfferClick } from 'src/routes/(subdomains)/(my)/[slug]/utils/externalOfferClickHelpers/externalOfferClickHelpers'

export const useGetHandleExternalOfferClick = (
  offer: Offer,
  registry: Registry,
  regItem?: RegItem
) => {
  const dispatch = useDispatch()
  const modal = useModal()

  return () => {
    if (!regItem) return

    handleExternalOfferClick({
      regItem,
      registry,
      offer,
      dispatch,
      closeModal: () => modal.hide(),
    })
  }
}

interface HandleExternalOfferClickArgs {
  regItem: RegItem
  registry: Registry
  offer: Offer
  dispatch: Dispatch<AnyAction>
  closeModal: () => void
}

const handleExternalOfferClick = ({
  regItem,
  registry,
  offer,
  dispatch,
  closeModal,
}: HandleExternalOfferClickArgs) =>
  handleOfferClick({
    regItem,
    registry,
    storeDisplayName: offer.storeDisplayName,
    url: offer.url,
    dispatch,
    closeModal,
  })
